var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCleaningImg = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.333)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11,0l2.53,8.47L22,11l-8.47,2.53L11,22,8.47,13.53,0,11,8.47,8.47Z",
    transform: "translate(0 0.333)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6,0,7.38,4.62,12,6,7.38,7.38,6,12,4.62,7.38,0,6,4.62,4.62Z",
    transform: "translate(15 14.333)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.5,0l.805,2.695L7,3.5l-2.695.805L3.5,7l-.8-2.695L0,3.5l2.7-.8Z",
    transform: "translate(0 1.333)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCleaningImg, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cleaningImg.19912e72.svg";
export { ForwardRef as ReactComponent };